import React from "react";

// Compact recreation of the Gormans Contracting mark: rooftops + tree + excavator
export function LogoMark({ className = "h-9 w-9" }) {
  return (
    <svg
      className={className}
      viewBox="0 0 64 48"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      aria-hidden="true"
    >
      {/* tree */}
      <circle cx="9" cy="16" r="7" fill="#7AB648" />
      <rect x="8" y="20" width="2" height="9" fill="#7AB648" />
      {/* rooftops */}
      <path d="M14 30 L26 18 L38 30 Z" fill="#A8AEB2" />
      <path d="M28 30 L40 18 L52 30 Z" fill="#FFFFFF" />
      {/* windows */}
      <rect x="23" y="26" width="4" height="4" fill="#14171A" />
      <rect x="38" y="26" width="4" height="4" fill="#14171A" />
      {/* excavator arm + cab */}
      <rect x="46" y="24" width="10" height="7" rx="1" fill="#7AB648" />
      <path d="M56 24 L62 18 L60 26 Z" fill="#7AB648" />
      {/* ground line */}
      <rect x="6" y="31" width="52" height="2" fill="#7AB648" />
      {/* tracks */}
      <rect x="45" y="33" width="13" height="4" rx="2" fill="#A8AEB2" />
    </svg>
  );
}

export function Logo({ dark = false, className = "" }) {
  return (
    <div className={`flex items-center gap-2.5 ${className}`} data-testid="brand-logo">
      <LogoMark />
      <div className="leading-none">
        <span
          className="font-head font-extrabold tracking-tight text-xl italic"
          style={{ color: dark ? "#14171A" : "#FFFFFF" }}
        >
          GORMANS
        </span>
        <span className="block font-head font-bold tracking-[0.35em] text-[9px] text-[#7AB648] mt-0.5">
          CONTRACTING
        </span>
      </div>
    </div>
  );
}

export default Logo;
